import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import UnLoggedHome from './home/UnLoggedHome'
import TeacherLogin from './login/TeacherLogin'
import TeacherHome from './home/LoggedHome'

import QuestionCreate from './question/QuestionCreate'
import QuestionManage from './question/QuestionManage'

import ExamCreate from './exam/ExamCreate'
import ExamManage from './exam/ExamManage'

import VoteCreate from './vote/VoteCreate'
import VoteManage from './vote/VoteManage'

function App() {
    return (
        <div className="App">
            <Router>
				<Switch>
                    
                    <Route path="/voteManage" component={VoteManage}/>
                    <Route path="/voteCreate" component={VoteCreate}/>

                    <Route path="/examManage" component={ExamManage}/>
                    <Route path="/examCreate" component={ExamCreate}/>

                    <Route path="/questionManage" component={QuestionManage}/>
                    <Route path="/questionCreate" component={QuestionCreate}/>
                    
                    <Route path="/teacherHome" component={TeacherHome}/>
                    <Route path="/teacherLogin" component={TeacherLogin}/>
                    <Route path="/studentLogin" component={TeacherLogin}/>
                    <Route path="/" component={UnLoggedHome} />
				</Switch>
			</Router>
        </div>
    );
}

export default App;